import { render, staticRenderFns } from "./ComparePage.vue?vue&type=template&id=e76de0bc"
import script from "./ComparePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ComparePage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports